import {fragments} from '@/gql';
import gql from 'graphql-tag';
export default gql`
  mutation provokeCallsheetAnalysis($input: provokeCallsheetAnalysisInput!) {
    provokeCallsheetAnalysis(input: $input) {
      ...provokeCallsheetAnalysisDetail
    }
  }
  ${fragments.provokeCallsheetAnalysisDetail}
`;
